import { cosApi } from '../api';

export const getApplePayMerchantSession = (validationURL: string) => {
  return cosApi.post(
    '/v3/apple_pay_session',
    {
      url: validationURL
    }
  );
};
